import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

/*
 * @Author: Nanxing Xiang
 * @Date: 2021-03-25 10:35:10
 * @LastEditors: 向南星 xiangnanxing@scmagic.cn
 * @LastEditTime: 2022-11-04 14:03:05
 * @Description: file content
 */
import React, { useEffect, useRef, useState } from 'react';

var EasPopup = function EasPopup(_ref) {
  var _context, _context2;

  var children = _ref.children,
      className = _ref.className,
      visible = _ref.visible,
      onClose = _ref.onClose,
      position = _ref.position;
  var flag = useRef(visible);

  var _useState = useState('hide'),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    if (!flag.current) {
      flag.current = true;
      return;
    }

    if (visible) {
      setState('in');
      setTimeout(function () {
        setState('');
      }, 300);
    } else {
      setState('out');
      setTimeout(function () {
        setState('hide');
      }, 500);
    }
  }, [visible]);

  var close = function close(e) {
    e.stopPropagation();

    if (state === '' && onClose) {
      onClose();
    }
  };

  return React.createElement("div", {
    className: _concatInstanceProperty(_context = "eas__popup ".concat(state, " popup__")).call(_context, position || 'bottom'),
    onClick: close
  }, React.createElement("div", {
    className: "popup__content".concat(className ? " ".concat(className) : ''),
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, _mapInstanceProperty(_context2 = React.Children).call(_context2, children, function (child) {
    return child;
  })));
};

export default React.memo(EasPopup);